<p>stores-empty works!</p>
